import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxPopupModule, DxCheckBoxModule, DxButtonModule } from 'devextreme-angular';
import { SharedModule } from '../../../../shared/shared.module';
import { AssignmentDto, AssignmentSubtableDataDto } from '../../../../shared/generated/backend';
import { ValueChangedEvent as CheckBoxValueChangedEvent } from 'devextreme/ui/check_box_types';

@Component({
  selector: 'app-pl-station-selection-dialog',
  standalone: true,
  imports: [CommonModule, DxPopupModule, DxCheckBoxModule, DxButtonModule, SharedModule],
  templateUrl: './pl-station-selection-dialog.component.html',
  styleUrl: './pl-station-selection-dialog.component.scss',
})
export class PlStationSelectionDialogComponent {
  visible = input(false);
  currentPlAssignment = input<AssignmentDto | null>(null);
  currentPlSubtableData = input<AssignmentSubtableDataDto | null>(null);
  selectedPlStations = input<number[]>([]);
  visibleChange = output<boolean>();
  selectedPlStationsChange = output<number[]>();
  plStationSelected = output<void>();

  closeDialog(): void {
    this.visibleChange.emit(false);
  }

  onPlStationToggle(assignmentNo: number, event: CheckBoxValueChangedEvent): void {
    const updated = [...this.selectedPlStations()];
    if (event.value) {
      if (!updated.includes(assignmentNo)) {
        updated.push(assignmentNo);
      }
    } else {
      const index = updated.indexOf(assignmentNo);
      if (index >= 0) {
        updated.splice(index, 1);
      }
    }
    this.selectedPlStationsChange.emit(updated);
  }

  handlePlStationSelected(): void {
    this.plStationSelected.emit();
  }

  isPlStationSelectable(station: Record<string, unknown>): boolean {
    // A station can be selected unless it is fully assigned (its planned amount
    // reached the main assignment's available amount). Requirement 7.1: a
    // fully-assigned station must not be planned again. Stations that are only
    // partially planned (assigned to some project but not fully) remain selectable.
    const isFullyAssigned = station['StationFullyAssigned'] === true;
    return !isFullyAssigned;
  }

  // Spec 1.7/1.2: m may legitimately have zero stations (or all of them may already
  // be fully assigned) - in that case there is nothing to select and Select must stay
  // enabled so m alone can still be planned. Only require a non-empty selection when
  // the main actually has at least one selectable station to choose from.
  hasSelectableStations(): boolean {
    return (this.currentPlSubtableData()?.PlStations ?? []).some(station => this.isPlStationSelectable(station));
  }

  formatPlStationDisplay(station: Record<string, unknown>): string {
    let display = station['AssignmentNo']?.toString() || '';

    if (station['EventDate']) {
      try {
        const date = new Date(station['EventDate'] as string);
        const dateStr = date.toLocaleDateString('de-DE');
        display += ' - ' + dateStr;
      } catch (_e) {
        display += ' - ' + station['EventDate'];
      }
    }

    const addressParts: string[] = [];
    if (station['EventAddress']) {
      addressParts.push(station['EventAddress'] as string);
    }
    if (station['EventZipCode'] || station['EventZip']) {
      addressParts.push((station['EventZipCode'] || station['EventZip']) as string);
    }
    if (station['EventCity']) {
      addressParts.push(station['EventCity'] as string);
    }

    if (addressParts.length > 0) {
      display += ' (' + addressParts.join(', ') + ')';
    }

    return display;
  }
}
